import React, {PureComponent} from 'react';
import bytes from 'bytes';

import {ImageresizeApi} from 'modules';
import {BadgeAd, BannerAd, ResponsiveTable, ShareBox} from 'components';
import {removeExtension, simplifyUrl} from 'utils';
import withPageTracking from 'hoc/withPageTracking';
import { Grid } from 'material-ui';

import CheckCircleIcon from 'assets/icons/check-circle.svg';

import styles from './styles';

class BulkImageDownload extends PureComponent {

  getImageName({ imageType, originalImage }) {

    if (imageType) {
      return `${removeExtension(originalImage.name)}.${imageType}`;
    }

    return originalImage.name;
  }

  renderImageInfo() {
    const {convertedImages} = this.props;
    const columns = {
      fileName: {
        filter: simplifyUrl,
        grow: true,
        heading: 'File Name'
      },
      size: {
        heading: 'New Size',
        width: '120px'
      },
      originalDimensions: {
        heading: 'Original (px)',
        width: '130px'
      },
      newDimensions: {
        bold: true,
        heading: 'New (px)',
        width: '130px'
      }
    };
    const rows = convertedImages.map((image) => ({
      fileName: this.getImageName(image),
      size: bytes(image.contentLength),
      originalDimensions: `${image.originalImage.dimensions.width} x ${image.originalImage.dimensions.height}`,
      newDimensions: `${image.dimensions.width} x ${image.dimensions.height}`
    }));

    return (
      <ResponsiveTable
        columns={ columns }
        rows={ rows }
        type="default"
      />
    );
  }

  render() {
    const {result} = this.props;

    // This images could not be converted, present a pretty error
    if (!result.archiveId) {
      return (
        <div className='error'>
          <p>The images could not be converted:</p>
          <p className='errorMessage'>{result.errorMessage}</p>
        </div>
      );
    }

    return (
      <div className='sideBySide container'>
        <div className='maxWidthSection'>
          <div className='section'>
            <h3 className={styles.verticalCenterChildren}>
              <CheckCircleIcon className={styles.rightMargin} height="32" width="32" />
              Your Images Are Ready
            </h3>
            {this.renderImageInfo()}
            <p><strong>Note:</strong> Images will be automatically removed from servers after 24 hrs.</p>
          </div>
          <div className='section'>
            <BannerAd />
            <Grid
              container
              className={styles.rightAlignText}
              direction="row"
              justify="flex-end"
              alignItems="center" >
              <div className='col-3 col-sm-6'>
                <a
                  className='button'
                  href={ImageresizeApi.getArchiveUrl(result.archiveId, `images-${new Date().toISOString()}`)}
                  target='_blank'
                >
                  Download Images
                </a>
              </div>
              <div className='col-3 col-sm-6'>
                <a
                  className='button'
                  href="https://www.gifmaker.net"
                  target='_blank'
                >
                  GIF From Images
                </a>
              </div>
            </Grid>
          </div>
          <div className='section'>
            <ShareBox />
          </div>
        </div>
        <BadgeAd />
      </div>
    );
  }
}

export default withPageTracking(BulkImageDownload, '/bulk-results.html');



// WEBPACK FOOTER //
// ./src/containers/BulkResize/BulkImageDownload.jsx